import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter, first, tap, withLatestFrom } from 'rxjs/operators';

import { getRouterUrl } from '@app/app.reducer';
import { getFormState } from '@shared/form/store/form.reducer';
import { ModalReset, ModalShow } from '@shared/modal/modal.actions';
import { getModalRedirectUrl, isModalConfirmed } from '@shared/modal/modal.reducer';

// TODO(MOJAT-3094): not good we need to refactor our modal component
const AUXILIARY_ROUTING_MODAL_PREFIX = '(modal:';
const OVERLAY_CLOSED_STRING = 'overaly closed';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  subscriptions: Subscription[] = [];
  dialogRef: MatDialogRef<any>;

  constructor(private store: Store<{}>, private router: Router) {}

  init(dialogRef: MatDialogRef<any>): void {
    this.dialogRef = dialogRef;
    this.dialogRef.disableClose = true;
    this.subscriptions.push(
      this.store
        .pipe(
          select(getFormState),
          first(),
          tap((formState) =>
            this.dialogRef
              .backdropClick()
              .subscribe(() => this.close(formState.data.closeWithoutAdditionalModal)),
          ),
        )
        .subscribe(),
    );
    this.subscriptions.push(
      this.store
        .pipe(
          select(isModalConfirmed),
          first(Boolean),
          withLatestFrom(this.store.pipe(select(getModalRedirectUrl))),
          tap(([, redirectUrl]: [any, string]) => {
            this.dialogRef.close(OVERLAY_CLOSED_STRING);
            !!redirectUrl
              ? this.router.navigateByUrl(redirectUrl)
              : this.router.navigate([{ outlets: { modal: null } }]);
          }),
        )
        .subscribe(),
    );
    // handle redirection from within the modal
    this.subscriptions.push(
      this.store
        .pipe(
          select(getRouterUrl),
          filter((url) => !url.includes(AUXILIARY_ROUTING_MODAL_PREFIX)),
        )
        .subscribe((url) => {
          this.dialogRef.close(OVERLAY_CLOSED_STRING);
        }),
    );
  }

  clean(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.store.dispatch(new ModalReset());
  }

  close(closeWithoutAdditionalModal = false) {
    if (closeWithoutAdditionalModal) {
      this.dialogRef.close(OVERLAY_CLOSED_STRING);
      this.router.navigate([{ outlets: { modal: null } }]);
    } else {
      this.store.dispatch(
        new ModalShow({
          title: 'Are you sure you want to leave this page?',
          message: 'All unsaved changes will be lost.',
        }),
      );
    }
  }
}
